"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const useStyles = (0, styles_1.makeStyles)(theme => ({
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    callForAction: {
        lineHeight: '300px',
        margin: '0',
        fontSize: '200px',
        fontWeight: 300,
    },
    statusCode: {
        margin: '0',
        fontSize: '160px',
        paddingRight: '40px',
        color: '#caf561',
        fontWeight: 300,
    },
    featuredSection: {
        display: 'flex',
        justifyContent: 'center',
    },
    subSection: {
        'alignItems': 'center',
        'display': 'flex',
        '& > p': {
            fontSize: '40px',
        },
    },
}));
const ErrorPage = ({ statusCode, text }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { "data-testid": "error-page_root", className: classes.root },
        react_1.default.createElement("div", { className: classes.featuredSection },
            react_1.default.createElement(Typography_1.default, { variant: "h1", component: "h1", className: classes.callForAction }, "Oops!")),
        react_1.default.createElement("div", { className: classes.subSection },
            react_1.default.createElement(Typography_1.default, { variant: "h2", component: "h2", className: classes.statusCode }, statusCode || 404),
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1", component: "p" }, text || `We couldn't find this page.`))));
};
exports.default = ErrorPage;
